import { useEffect } from 'react';

export const useDetectBackNavigation = (onBackNavigation) => {
  useEffect(() => {
    const initialUrl = window.location.href;

    const handlePopState = () => {
      const currentUrl = window.location.href;

      if (currentUrl !== initialUrl) {
        if (typeof onBackNavigation === 'function') {
          onBackNavigation();
        }
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [onBackNavigation]);
};
